<script>
import ActionBar from '@/components/core/ActionBar.vue';

export default {
  extends: ActionBar,
  data() {
    return {
      resourceName: 'App',
      urlFragment: 'applications',
    };
  },
};
</script>

<style></style>
